// THIS IS GLOBAL REACT FILE FROM ECOSYSTEM54.
// IF YOU WANT TO CHANGE THIS FILE, PLEASE CONTACT THE MAIN FRONTEND DEVELOPER ON THE ECOSYSTEM54
// UPDATED 2024.03.19 || YYYY/MM/DD

import Cookies from 'universal-cookie';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export function logoutAndClearAllCookies(callback) {
  try {
    // The "expire" attribute of every cookie is
    // Set to "Thu, 01 Jan 1970 00:00:00 GMT"
    document.cookie.split(';').forEach((c) => {
      document.cookie = `${c.trim().split('=')[0]}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });

    // localStorage.clear();
    callback?.();
  } catch (e) {
    console.log('Something wrong with cookies', e);
  }
}

export const getNameForActor = (actor) => {
  const {
    actor_type: actorType,
    uinfo: {
      first_name: firstNameUINFO,
      last_name: lastNameUINFO,
      group_name: groupNameUINFO,
      service_name: serviceNameUINFO,
    } = {},
    first_name: firstNameActor,
    last_name: lastNameActor,
    group_name: groupNameActor,
    service_name: serviceNameActor,
  } = actor || {};

  const emptyName = 'name not found';

  const firstName = firstNameUINFO || firstNameActor || '';
  const lastName = lastNameUINFO || lastNameActor || '';
  const groupName = groupNameUINFO || groupNameActor || '';
  const serviceName = serviceNameUINFO || serviceNameActor || '';

  switch (actorType) {
    case 'user':
    case 'classic_user':
      return firstName || lastName ? `${firstName} ${lastName}` : emptyName;
    case 'group':
      return groupName || emptyName;
    case 'service':
      return serviceName || emptyName;
    default:
      return ((firstName || lastName) && (`${firstName} ${lastName}`)) || groupName || serviceName || emptyName;
  }
};

export const getInitialsNameOfActor = (actor) => getNameForActor(actor)
  .split(' ')
  .map((item) => item[0])
  .join('')
  .toUpperCase();

export const getCookie = (cookie) => {
  const cookies = new Cookies();

  return cookies.get(cookie);
};

export const setCookie = (name, value, options) => {
  const cookies = new Cookies();

  return cookies.set(name, value, options);
};

export const removeCookie = (name) => {
  try {
    const cookies = new Cookies();

    cookies.remove(name, { path: '/' });
  } catch (e) {
    console.log('remove cookie', e);
  }
};

export const parseErrorFromRequest54origins = (error) => {
  const {
    status = 500,
    data: {
      error_message: errMessage = '',
      error_content: errContent = [],
      message: anotherErrMessage = '',
    } = {},
  } = error?.response || {};

  let finalErrMessage = errMessage || anotherErrMessage;

  if (errContent.length > 0) {
    finalErrMessage = errContent
      .map(({
        field,
        message,
      }) => `${field}: ${message}`)
      .join('\t');
  }

  return {
    message: finalErrMessage,
    status,
  };
};

export const stopPropagation = (e) => e?.stopPropagation();

export const dateFormat54origins = (date) => {
  const dateObj = dayjs.utc(date);
  const formattedDate = (dateParam) => dateObj.local().format(dateParam);

  return {
    date: formattedDate('DD-MM-YYYY'),
    dateWithTime: formattedDate('DD-MM-YYYY | HH:mm'),
    dateMonthWithTime: formattedDate('MMM D YYYY | HH:mm'),
  };
};

export const actorsIsBanned = (actorData, banGroupUUID) => !!((actorData?.uinfo?.groups?.includes(banGroupUUID)));

export const actorIsAdmin = (actorData, adminGroupUUID) => !!((actorData?.is_admin || actorData?.uinfo?.groups?.includes(adminGroupUUID)));

export const actorIsRoot = (actorData) => {
  const { is_root = false, root = false, root_perms_signature = '' } = actorData || {};

  return !!((is_root || root || root_perms_signature));
};

export const actorIsRootOrAdmin = (actorData, adminGroupUUID) => (actorIsAdmin(actorData, adminGroupUUID) || actorIsRoot(actorData));

export const checkStringIsEmpty = (str) => str?.replace(/\s/g, '').length === 0;
